import React from 'react';
import {connect} from 'react-redux';
import PartnerList from './PartnerList';
import actions from './actions';
import AdminBaseLayoutContainer from "../../components/BaseLayout/AdminBaseLayoutContainer";


const mapStateToProps = state => {
  return {
    ...state.partners,
  };
};

const mapDispatchToProps = actions;

class PartnerListContainer extends React.Component {

  componentDidMount() {
    this.props.onInit()
  }

  render() {
    return (
      <AdminBaseLayoutContainer>
        <PartnerList {...this.props}/>
      </AdminBaseLayoutContainer>
    )
  }

}


export default connect(mapStateToProps, mapDispatchToProps)(PartnerListContainer);
